export default "__VITE_ASSET__1b054478__"